import { InvoiceDetailsComponent } from './invoice-details/invoice-details.component';
import { UserSearchDto } from './../../users/shared/dto/user-search.dto';
import { InvoiceUpsertDto } from '../dto/invoice-upsert.dto';
import { CreditCardPaymentInfo } from './../../revenue/shared/credit-card/credit-card-payment-info.model';
import { BillingDto } from './../../revenue/shared/billing/dto/billing.dto';
import { BillingService } from './../../revenue/shared/billing/billing.service';
import { CreditCardPaymentDto } from './invoice-payment/credit-card-payment/dto/credit-card-payment.dto';
import { UserSummaryDto } from './../../users/shared/dto/user-summary.dto';
import { UserService } from './../../users/shared/user.service';
import { RevenueItem } from './../../revenue/shared/revenue-items/revenue-item.model';
import { RevenueItemService } from './../../revenue/shared/revenue-items/revenue-item.service';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { PagedSearch } from 'src/app/shared';
import { InvoicePaymentComponent } from './invoice-payment/invoice-payment.component';
import { InvoiceAdjustmentComponent } from './invoice-adjustment/invoice-adjustment.component';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-invoice-builder',
  templateUrl: './invoice-builder.component.html',
  styleUrls: ['./invoice-builder.component.less'],
    standalone: false
})
export class InvoiceBuilderComponent implements OnInit {
  @Input() invoice: InvoiceUpsertDto;
  @Input() creditCardPayment: CreditCardPaymentInfo;
  @Input() profileId: number;
  @Input() isNewMemberInvoice = false;
  @Input() paymentTypeInvalid: boolean;
  @Output() paymentTypeSelected = new EventEmitter<void>();

  @ViewChild(InvoicePaymentComponent) paymentsComponent: InvoicePaymentComponent;
  @ViewChild('lineItemAdjustments', { static: false }) lineItemAdjustmentsComponent: InvoiceAdjustmentComponent;
  @ViewChild('paymentAdjustments', { static: false }) paymentAdjustmentsComponent: InvoiceAdjustmentComponent;
  @ViewChild(InvoiceDetailsComponent) invoiceDetails: InvoiceDetailsComponent;

  public allRevenueItems: RevenueItem[];
  public activeRevenueItems: RevenueItem[];
  public allUsers: UserSummaryDto[];
  public billingDto: BillingDto;

  public get sendAutomaticReceipt() {
    return this.paymentsComponent.sendAutomaticReceipt;
  }

  constructor(
    public securityElementNames: SecurityElementNames,
    private _revenueItemService: RevenueItemService,
    private _userService: UserService,
    private _billingService: BillingService
  ) {}

  ngOnInit() {
    this._revenueItemService.getAllRevenueItems().then((data) => {
      this.allRevenueItems = data.sort((a, b) => {
        return a.ItemName < b.ItemName ? -1 : a.ItemName > b.ItemName ? 1 : 0;
      });
      this.activeRevenueItems = this.allRevenueItems.filter((x) => {
        return !x.Inactive;
      });
    });
    this._userService.search({ PageNumber: 0, PageSize: 0, OrderBy: 'UserName:ASC' } as UserSearchDto).then((data) => {
      this.allUsers = data.Result;
    });
    this._billingService.getBillingsForProfile(this.profileId).then((data) => {
      if (data.Result && data.Result.length) {
        this.billingDto = data.Result[0];
      }
    });
  }

  // used for hiding the create new payment & adjustment sections after a successful save
  public cancelNewPaymentsAndAdjustments() {
    this.paymentsComponent.addingNewPayment = false;
    this.lineItemAdjustmentsComponent.addingNewAdjustment = false;
    this.paymentAdjustmentsComponent.addingNewAdjustment = false;
  }

  onPaymentTypeSelected() {
    this.paymentTypeSelected.emit();
  }
}
